// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pic{width:250px;height:140px}.row{margin:20px}.bold{font-weight:700}.el-table__expanded-cell,.el-table__expanded-cell:hover{background-color:#f5f7fa!important}", ""]);
// Exports
module.exports = exports;
